import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var r = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1124 -900)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "black"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10 0H0V20H10V0Z",
      fill: "#A2001D"
    })
  ]
});
export {
  r as default
};
